interface BlogHeaderProps {
  title?: string
  description?: string
}

export function BlogHeader({
  title = 'Blog',
  description = 'Learn about building modern web applications, edge computing, and best practices for SaaS development.',
}: BlogHeaderProps) {
  return (
    <div className="mb-16">
      <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-4">{title}</h1>
      <p className="text-lg text-muted-foreground leading-relaxed">{description}</p>
    </div>
  )
}
